<template>
  <v-dialog v-model="show" width="350px">
    <v-card>
      <v-card-title style="margin-bottom: 1rem">
        <h2 style="text-align: center; font-size: 1rem">Pilih Bulan & Tahun</h2>
      </v-card-title>
      <v-row justify="center">
        <v-date-picker v-model="periode" type="month" />
      </v-row>

      <v-card-actions>
        <v-spacer />
        <v-btn color="error" variant="text" @click="close"> Batal </v-btn>
        <v-btn
          color="primary"
          variant="text"
          @click="
            () => {
              // close()
              download();
            }
          "
        >
          Download
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import axios from '@/libs/axios';

export default {
  data() {
    return {
      show: false,
      periode: '',
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    async download() {
      const date = moment(`${this.periode}-01`, 'YYYY-MM-DD');

      const from = date.startOf('month').format('YYYY-MM-DD');
      const to = date.endOf('month').format('YYYY-MM-DD');
      try {
        const response = await axios.get('/receivables/download', {
          responseType: 'blob',
          params: {
            from: from,
            to: to,
          },
        });

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `List Piutang ${from} - ${to}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url); // free up memory
      } catch (error) {
        console.error('Download failed:', error);
      }
    },
  },
};
</script>
